<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
          </h6>

          <Menu/>

          <div class="element-box mt-4">
            <div class="row mt-2">
              <!-- 1. Einzelcoaching -->
              <CoachingButton
                  :enabled="companySettings?.privateCoachingEnabled"
                  route-name="privateCoachingNewAndActiveList"
                  coaching-type="private"
                  label="Einzelcoaching"/>

              <!-- 2. Gruppenmaßnahmen -->
              <CoachingButton
                  :enabled="companySettings?.groupCoachingEnabled"
                  route-name="groupCoachingNewAndActiveList"
                  icon="fa-users"
                  coaching-type="group"
                  label="Gruppenmaßnahmen"/>
            </div>
          </div>

          <h6 class="mt-5">{{ $t('general.active_customers') }}</h6>
          <div class="row g-4 mt-1">
            <!-- 1. Einzelcoaching -->
            <div class="col-lg-3 col-md-6 col-sm-12"
                 v-if="companySettings?.privateCoachingEnabled">
              <CoachingCardInfo
                  label="Einzelcoaching"
                  type="private"
                  :value="infoData?.countActiveCoaching?.counts?.privateCoaching"
              />
            </div>

            <!-- 2. Gruppenmaßnahmen -->
            <div class="col-lg-3 col-md-6 col-sm-12"
                 v-if="companySettings?.groupCoachingEnabled">
              <CoachingCardInfo
                  label="Gr.-Maßnahmen"
                  type="group"
                  :value="infoData?.countActiveCoaching?.counts?.groupCoaching"
              />
            </div>
          </div>

          <div v-if="companySettings?.locationEnabled" class="mt-4">
            <h6 class="section-subtitle mb-3">
              Übersicht Standorte
            </h6>

            <div class="row g-4">
              <!-- 1. Interne Standorte -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Interne Standorte"
                    type="internalLocation"
                    :value="infoData?.countInternalOffices"
                />
              </div>

              <!-- 2. Externe Standorte -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Externe Standorte"
                    type="externalLocation"
                    :value="infoData?.countExternalOffices"
                />
              </div>

              <!-- 3. Sonstige Standorte -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Sonstige Standorte"
                    type="otherLocation"
                    :value="infoData?.countOtherOffices"
                />
              </div>
            </div>
          </div>

          <div class="element-box mb-3 mt-4">
            <h6>Einheiten im Jahr {{ filterData.year }} fertiggestellt</h6>
            <div class="row mt-4">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.coachingType"
                        :options="filteredCoachingTypes"
                        :is-clear="false"
                    />
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.year"
                        :options="dropdownYears"
                        :is-clear="false"
                    />
                  </div>
                  <div class="col-lg col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.locationId"
                        placeholder="Standort"
                        :options="dropdownOffices"
                        :is-clear="true"
                    />
                  </div>

                  <div class="col-auto text-center">
                    <button class="btn btn-primary custom_search_button2" @click="getChartBar(true)">
                      <span v-if="isSearching">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t('general.button.search_in_progress') }}
                      </span>
                      <span v-else>
                        {{ $t('general.button.search') }}
                      </span>
                    </button>
                  </div>
                </div>
                <VueApexCharts width="100%" type="bar" :options="chartOptionsBar" :series="seriesSignBar"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormSidebar>
        <template #top>
          <h6 class="element-header">
            Sidebar
          </h6>
        </template>

        <div class="element-box pie mt-2">
          <h6>{{ $t('general.active_customers') }}</h6>
          <VueApexCharts
              :key="seriesActiveCoach.length"
              width="100%"
              type="donut"
              :options="chartOptions"
              :series="seriesActiveCoach"/>
        </div>
        <div class="element-box">
          <h6>Standorte nach Bundesländern</h6>
          <div v-for="user of infoData?.countOfficeByFederalState" v-bind:key="user?.name"
               class="d-flex justify-content-between">
            <span>{{ user?.federalState }}</span>
            <span>{{ user?.count }}</span>
          </div>
        </div>

        <div class="element-box mt-2" v-if="infoData?.todayBirthdays?.length">
          <Birthday :birthdays="infoData?.todayBirthdays" />
        </div>
      </FormSidebar>
    </div>
  </div>
</template>

<script setup>
import dashboardHeadAMDLService from '@/api/Dashboard/HeadAMDL';
import Birthday from '@/components/Birthday.vue';
import CoachingButton from '@/components/button/CoachingButton.vue';
import CoachingCardInfo from '@/components/card/CoachingCardInfo.vue';
import FormSidebar from '@/components/FormSidebar.vue';
import SelectVue from '@/components/SelectVue.vue';
import { ErrorToast } from '@/components/VueToast';
import { getCoachingTypes, getOfficeDropdown, getYears } from '@/shared/dropdowns';
import { getDonutColorsByCompany, optionsChartBar, optionsChartDonut } from '@/shared/utils/apex';
import { MonthsUtils } from '@/shared/utils/MonthsUtils';
import { piniaCompanySettingsStore } from '@/store/piniaCompanySettingsStore';
import { piniaUserStore } from '@/store/piniaUserStore';
import Menu from '@/views/App/Dashboard/HeadAMDL/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import VueApexCharts from 'vue3-apexcharts';

const { t }             = useI18n();

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const chartOptions      = ref(optionsChartDonut);
const seriesActiveCoach = ref([]);

const seriesSignBar = ref([]);

const chartOptionsBar = ref({
  ...optionsChartBar,
  xaxis: {
    categories: MonthsUtils(t),
  },
  colors: [
    'rgba(67, 173, 78, 0.6)',
    'rgba(75, 192, 192, 0.6)',
  ],
  plotOptions: {
    bar: {
      distributed: false,
    },
  },
});

const dropdownYears        = ref([]);
const dropdownCoachingType = ref([]);
const dropdownOffices      = ref([]);
const isSearching          = ref(false);

const filterData = ref({
  coachingType: 'private_coaching',
  year: new Date().getFullYear(),
  locationId: '',
});

const infoData = ref({});

async function getInfoData() {
  try {
    const { data } = await dashboardHeadAMDLService.getInfoData();
    infoData.value = data.data;

    const counts = data.data.countActiveCoaching?.counts ?? {};
    const series = [
      counts.privateCoaching ?? 0,
      counts.groupCoaching ?? 0,
    ];
    const countActiveCoachingTotal = series.reduce((sum, value) => sum + value, 0);

    seriesActiveCoach.value = series;
    chartOptions.value      = {
      ...chartOptions.value,
      colors: getDonutColorsByCompany(companySettings.value?.companyKey),
      responsive: [ {
        breakpoint: 2480,
        options: {
          chart: {
            width: '100%',
            height: 300,
          },
          legend: {
            position: 'bottom',
          },
        },
      } ],
      labels: [
        `Einzelcoaching ${series[0]}`,
        `Gruppenmaßnahmen ${series[1]}`,
      ],

      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'left',
        fontSize: '11px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 400,
        textColor: '#64748b',
        itemMargin: {
          horizontal: 6,
          vertical: 2
        },
        markers: {
          width: 8,
          height: 8,
          radius: 12,
          offsetX: -3
        }
      },

      plotOptions: {
        pie: {
          donut: {
            ...chartOptions.value.plotOptions.pie.donut,
            labels: {
              ...chartOptions.value.plotOptions.pie.donut.labels,
              total: {
                ...chartOptions.value.plotOptions.pie.donut.labels.total,
                formatter: () => countActiveCoachingTotal.toString(),
              },
            },
          },
        },
      },
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getChartBar() {
  try {
    isSearching.value   = true;
    const { data }      = await dashboardHeadAMDLService.getUnitsDoneChart(filterData.value);
    seriesSignBar.value = [ data.data.chartData.signedUnits, data.data.chartData.unsignedUnits ];
    isSearching.value   = false;
  } catch (error) {
    isSearching.value = false;
    await ErrorToast(error);
  }
}

const filteredCoachingTypes = computed(() =>
    dropdownCoachingType.value.filter(
        item => item.value === 'private_coaching' || item.value === 'group_coaching',
    ),
);

onMounted(() => {
  getInfoData();
  getChartBar();
  getYears(dropdownYears);
  getCoachingTypes(dropdownCoachingType);
  getOfficeDropdown(dropdownOffices);
});
</script>

<style scoped>
::v-deep(.pie .apexcharts-legend) {
  display: block !important;
}
</style>